module.exports = __webpack_public_path__ + "img/暂无数据.12c9a105.png";